<template>
    <div class="px-0">
        <v-container class="px-0 py-5" style="max-width: 100% !important">
            

            <v-card class="px-0 size">
                <v-card-text class="py-3">
                    <v-row class="px-3">
                        <v-col cols="4" justify="end" align="start">
                            <h3 class="pt-2">{{ $t('yego_dashboard.business_intelligence_dashboard') }}</h3>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="4" justify="end" align="end">

                            <v-tooltip bottom>
                                <template v-slot:activator="{ on: tooltip }">
                                    <v-menu v-model="settings_menu" offset-y left bottom :closeOnContentClick="false" :scrim="false" class="px-0">
                                        <template v-slot:activator="{ on: menu }">
                                            <v-btn v-on="{...tooltip, ...menu}" class="right" style="max-width: 25px !important; min-width: 25px !important" plain @click="settings_menu = true;">
                                                <v-icon class="material-icons-outlined">tune</v-icon>
                                            </v-btn>
                                                
                                        </template>

                                        <efficiency_options v-if="component_showed == 'efficiency'" :efficiency_options="efficiency_options" @efficiency_options="handleEfficiencyOptions"></efficiency_options>
                                        <buyout_options v-if="component_showed == 'buyout'" :buyout_options="buyout_options" @buyout_options="handleBuyoutOptions"></buyout_options>
                                        <days_in_transit_options v-if="component_showed == 'days_in_transit'" :days_in_transit_options="days_in_transit_options" @days_in_transit_options="handleDaysInTransitOptions"></days_in_transit_options>
                                    </v-menu>
                                </template>
                                <span>{{$t('yego_dashboard.settings')}}</span>
                            </v-tooltip>
                        </v-col>
                    </v-row>

                    <v-row class="px-6 pb-2">
                        <v-chip class="mr-2" ref="efficiency" outlined @click="showComponent('efficiency')" :class="component_showed == 'efficiency' ? 'chip-enabled': 'chip-disabled'">{{ $t('yego_dashboard.efficiency') }}</v-chip>
                        <v-chip class="mr-2" ref="buyout" outlined @click="showComponent('buyout')" :class="component_showed == 'buyout' ? 'chip-enabled': 'chip-disabled'">{{ $t('yego_dashboard.buyout') }}</v-chip>
                        <v-chip class="mr-2" ref="days_in_transit" outlined @click="showComponent('days_in_transit')" :class="component_showed == 'days_in_transit' ? 'chip-enabled': 'chip-disabled'">{{ $t('yego_dashboard.days_in_transit') }}</v-chip>
                    </v-row>

                    <v-row class="px-3 pt-2 pb-2">
                        <v-col cols="2" class="py-0 my-0">
                            <client-selector :addAllOption="false" class="py-0 my-0 " ref="clientSelector" @getClients="v => items.clients = v" :is_national="2" :only_fulfillment="1" :cod="1"></client-selector>  
                        </v-col>
                        <!-- <v-col class="pt-2 py-0" cols="2">
                            <v-autocomplete class="mt-0" v-model="period" :items="periods" :label="$t('dashboard.period')"></v-autocomplete> 
                        </v-col> -->
                        <v-col class="py-0 my-0" cols="1">
                            <v-autocomplete class="my-0 py-1" v-model="year" :items="years" :label="$t('yego_dashboard.year')"></v-autocomplete> 
                        </v-col>
                        <v-col class="py-0 my-0" cols="2">
                            <v-autocomplete class="my-0 py-1" v-model="shipping_service" :items="shipping_services" text="text" value="value" :label="$t('yego_dashboard.shipping_service')"></v-autocomplete> 
                        </v-col>
                    </v-row>

                    <v-row class="px-3" align="center" justify="center" v-if="component_showed == 'efficiency'">
                        <v-col cols="12" class="pt-3 px-0">
                            <efficiency :data="data" :selected_months="selected_months" :options="efficiency_options" :showed_options="efficiency_showed_options" :year="year" @leftMonth="handleMonthChange('left')" @rightMonth="handleMonthChange('right')"></efficiency>
                        </v-col>
                    </v-row>

                    <v-row class="px-3" align="center" justify="center" v-if="component_showed == 'buyout'">
                        <v-col cols="12" class="pt-3 px-0">
                            <buyout :data="data" :selected_months="selected_months" :options="buyout_options" :year="year" @leftMonth="handleMonthChange('left')" @rightMonth="handleMonthChange('right')"></buyout>
                        </v-col>
                    </v-row>

                    <v-row class="px-3" align="center" justify="center" v-if="component_showed == 'days_in_transit'">
                        <v-col cols="12" class="pt-0 px-0">
                            <days_in_transit :current_month="current_month" :summary_data="summary_data" :transit_data="transit_data" @leftMonth="handleOneMonthChange('left')" @rightMonth="handleOneMonthChange('right')"></days_in_transit>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>    
        </v-container> 
    </div>
</template>

<script>

import { HttpYegoDashboardRepository } from '../infrastructure/repositories/yego_dashboard_repository'
import { efficiencyYBIUseCase } from '../application/use_cases/efficiency_ybi_use_case';
import { efficiencyYBIFinishedUseCase } from '../application/use_cases/efficiency_ybi_finished_use_case';
import { buyoutYBIUseCase } from '../application/use_cases/buyout_ybi_use_case'
import { summaryTransitYBIUseCase } from '../application/use_cases/summary_transit_ybi_use_case';
import { transitYBIUseCase } from '../application/use_cases/transit_ybi_use_case';
import { transitPickupYBIUseCase } from '../application/use_cases/transit_pickup_ybi_use_case';

export default {
	components: {
        headers(){
            return [
                { text: this.$t('payments.client'), value: 'client_id' },
            ];
        }
    },
    data(){
        return {
            period: 'quarterly',
            periods: [
                { text: this.$t('dashboard.quarterly'), value: 'quarterly'},
            ],
            year: new Date().getFullYear(),
            years: this.$store.state.years_catalog,
            efficiency_options: {
                deliveries: true,
                returns: true,
                other: true,
                all: true,
                green: { min: 56, max: 100 },
                yellow: { min: 51, max: 55 },
                red: { min: 0, max: 50 },
                month_left: { sort: false, type: '' },
                month_center: { sort: false, type: '' },
                month_right: { sort: false, type: '' },
                result_types: ['all', 'finished'],
                result_type: 'all'
            },
            buyout_options : {
                green: { min: 51, max: 100 },
                red: { min: 0, max: 50 },
                month_left: { sort: false, type: '' },
                month_center: { sort: false, type: '' },
                month_right: { sort: false, type: '' }
            },
            days_in_transit_options: {
                result_types: ['creation', 'pickup'],
                result_type: 'creation'
            },
            months: [
                { month: 0, es: 'Enero', en: 'January', days: 31},
                { month: 1, es: 'Febrero', en: 'February', days: 28},
                { month: 2, es: 'Marzo', en: 'March', days: 31},
                { month: 3, es: 'Abril', en: 'April',days: 30},
                { month: 4, es: 'Mayo', en: 'May', days: 31},
                { month: 5, es: 'Junio', en: 'June', days: 30},
                { month: 6, es: 'Julio', en: 'July', days: 31},
                { month: 7, es: 'Agosto', en: 'August', days: 31},
                { month: 8, es: 'Septiembre', en: 'September', days: 30},
                { month: 9, es: 'Octubre', en: 'October', days: 31},
                { month: 10, es: 'Noviembre', en: 'November', days: 30},
                { month: 11, es: 'Diciembre', en: 'December', days: 31},
            ],
            shipping_services: [
                { value: "AFIMEX", text: "AFIMEX" },
                { value: "FEDEX", text: "FEDEX" }, 
                { value: "IHS", text: "IHS" },
                { value: "QUALITYPOST", text: "QUALITY POST"}
            ],
            efficiency_showed_options: ['delivered', 'returned', 'others'],
            selected_months: [],
            data: null,
            shipping_service: 'FEDEX',
            settings_menu: false,
            component_showed: 'efficiency',
            current_month: null,
            summary_data: null,
            transit_data: null,
        }
    },
    mounted(){
        this.index();

        this.$store.state.module = "headers.dashboard";
    },
    methods: {
        methodHandler(object){
            this[object.methodName](object.parameters)
        },
        async index() {
            this.selected_months = this.getLast3FullMonths(null);
            this.current_month = this.getMonth(null);
        },
        async reload(){              
            if(this.component_showed == 'efficiency') this.loadEfficiency();
            else if(this.component_showed == 'buyout') this.loadBuyOut();
            else if(this.component_showed == 'days_in_transit') this.loadDaysInTransit();
        },
        handleMinInput(color) {
            if (this.efficiency_options[color].min.length >= 2) {
                this.$nextTick(() => {
                    this.$refs[color + '_max'].focus();
                });
            }
        },
        async handleMonthChange(value){
            if(value == 'left') {
                this.selected_months = this.getLast3FullMonths("less");

                await this.reload();
            }
            else if(value == 'right'){
                this.selected_months = this.getLast3FullMonths("more");

                await this.reload();
            }
        },
        async handleOneMonthChange(value) {
            if(value == 'left') {
                this.current_month = this.getMonth("less");

                await this.reload();
            }
            else if(value == 'right'){
                this.current_month = this.getMonth("more");

                await this.reload();
            }
        },
        getLast3FullMonths(slice) {
            const date = new Date();
            var currentMonth = null;            

            if(slice == null) {
                currentMonth = date.getMonth();
                currentMonth -= 1;
            }
            else {
                currentMonth = this.selected_months[2].month;

                if(slice == "more"){
                    if(currentMonth == 11) {
                        currentMonth = 0;
                        if(this.year < new Date().getFullYear()) this.year++;
                    } 
                    else currentMonth += 1;
                } 
                if(slice == "less"){
                    if(currentMonth == 0) {
                        currentMonth = 11;
                        if(this.year > 2017) this.year--;
                    } 
                    else currentMonth -= 1;
                } 
            }

            const months = [];
            const monthNames = this.months;

            for (let i = 0; i < 3; i++) {
                if (currentMonth < 0) {
                    currentMonth = 11; // saltar al año anterior
                }
                months.unshift(monthNames[currentMonth]);
                currentMonth--;
            }

            return months;
        },
        getMonth(slice){
            const date = new Date();
            var currentMonth = null;            

            if(slice == null) {
                currentMonth = date.getMonth();
            }
            else {
                currentMonth = this.current_month[0].month;
                if(slice == "more"){
                    if(currentMonth == 11) {
                        currentMonth = 0;
                        if(this.year < new Date().getFullYear()) this.year++;
                    } 
                    else currentMonth += 1;
                } 
                if(slice == "less"){
                    if(currentMonth == 0) {
                        currentMonth = 11;
                        if(this.year > 2017) this.year--;
                    } 
                    else currentMonth -= 1;
                } 
            }

            const months = [];
            const monthNames = this.months;

            months.unshift(monthNames[currentMonth]);

            return months;  
        },
        showComponent(component) {
            this.component_showed = component;
        },
        async loadEfficiency(){
            this.efficiency_showed_options = [];

            if(this.efficiency_options.deliveries) this.efficiency_showed_options.push("delivered");
            if(this.efficiency_options.returns) this.efficiency_showed_options.push("returned");
            if(this.efficiency_options.other) this.efficiency_showed_options.push("others");
            
            if(this.$store.state.clientId == null || this.period == '' || this.year == '' || this.shipping_service == '') return;

            try{
                let response = null;
                if(this.efficiency_options.result_type == 'all') response = await efficiencyYBIUseCase(this.$store.state.clientId, this.period, this.year, this.selected_months[2].month, this.shipping_service, HttpYegoDashboardRepository);                
                else response = await efficiencyYBIFinishedUseCase(this.$store.state.clientId, this.period, this.year, this.selected_months[2].month, this.shipping_service, HttpYegoDashboardRepository);

                this.data = response;
            } catch (e) {
                console.log(e);
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        },
        async loadBuyOut(){
            if(this.$store.state.clientId == null || this.period == '' || this.year == '' || this.shipping_service == '') return;

            try{
                const response = await buyoutYBIUseCase(this.$store.state.clientId, this.period, this.year, this.selected_months[2].month, this.shipping_service, HttpYegoDashboardRepository);                

                this.data = response;
            } catch (e) {
                console.log(e);
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        },
        async loadDaysInTransit() {
            if(this.$store.state.clientId == null || this.year == '' || this.shipping_service == '' || this.current_month == null) return;

            try{
                const response_summary = await summaryTransitYBIUseCase(this.year, this.current_month[0].month, this.$store.state.clientId, this.shipping_service, HttpYegoDashboardRepository);                

                let response = null
                if(this.days_in_transit_options.result_type == "creation") response = await transitYBIUseCase(this.year, this.current_month[0].month, this.$store.state.clientId, this.shipping_service, HttpYegoDashboardRepository);
                else response = await transitPickupYBIUseCase(this.year, this.current_month[0].month, this.$store.state.clientId, this.shipping_service, HttpYegoDashboardRepository);
                

                this.summary_data = response_summary;
                this.transit_data = response;
            } catch (e) {
                console.log(e);
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        },
        async handleEfficiencyOptions(event){
            this.efficiency_options = event;

            await this.reload();
        },
        async handleBuyoutOptions(event){
            this.buyout_options = event;

            await this.reload();
        },
        async handleDaysInTransitOptions(event) {
            this.days_in_transit_options = event;

            await this.reload();
        }
    },
    watch:{
        '$store.state.clientId': async function (){
            if (this.$store.state.clientId == null) return;
            
            await this.reload();
        },
        'efficiency_options.green.min': async function() {
            if(this.efficiency_options.green.min == "") this.efficiency_options.green.min = 0;
            this.efficiency_options.yellow.max = parseInt(this.efficiency_options.green.min) - 1;
        },
        'efficiency_options.yellow.min': async function() {
            if(this.efficiency_options.yellow.min == "") this.efficiency_options.yellow.min = 0;
            this.efficiency_options.red.max = parseInt(this.efficiency_options.yellow.min) - 1;
        },
        'efficiency_options.yellow.max': async function() {
            if(this.efficiency_options.yellow.max == "") this.efficiency_options.yellow.max = 0;
            this.efficiency_options.green.min = parseInt(this.efficiency_options.yellow.max) + 1;
        },
        'efficiency_options.red.max': async function() {
            if(this.efficiency_options.red.max == "") this.efficiency_options.red.max = 0;
            this.efficiency_options.yellow.min = parseInt(this.efficiency_options.red.max) + 1;
        },
        'efficiency_options.result_type': async function() {
            if (this.$store.state.clientId == null) return;
            
            if(this.efficiency_options.result_type == "finished") {
                const index = this.efficiency_showed_options.indexOf("others");
                if (index !== -1) this.efficiency_showed_options.splice(index, 1);
            }
            else {
                this.efficiency_showed_options = ['delivered', 'returned', 'others'];
            }    
        },
        'year': async function(){
            await this.reload();
        },
        'shipping_service': async function(){
            await this.reload();
        },
        'component_showed': async function() {
            await this.reload();
        }
    }
}
</script>

<style>

</style>
